import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaEvent } from "@/lib/metaCapi";

const MetaPageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackMetaEvent({ eventName: "PageView" });
  }, [location.pathname, location.search]);

  return null;
};

export default MetaPageViewTracker;
